import $axios from '@src/_common/service/httpServer'
import axios from 'axios'
export default $axios
